/**
 * The skips-left line and the one skip control the Game tab shows (ISSUE-1044,
 * SUR-R87): Skip this round on an open round, Undo skip after a skip. Both
 * are secondary; Save in the status dock stays the tab's one primary action.
 */
import { Button } from "@sportsmet/ui";
import type { JSX } from "react";

import {
  SURVIVOR_SKIP_ROUND_LABEL,
  SURVIVOR_UNDO_SKIP_LABEL,
} from "./survivorGameCopy";
import type { typeSkipRowView } from "./survivorSkipModel";

export type typeSurvivorSkipRowProps = {
  view: typeSkipRowView;
  isPending: boolean;
  onSkip: () => void;
  onUndo: () => void;
};

export function SurvivorSkipRow(props: typeSurvivorSkipRowProps): JSX.Element {
  const isDeclare = props.view.kind === "declare";
  return (
    <div
      data-testid="survivor-skip-row"
      className="flex items-center justify-between gap-3"
    >
      <p
        data-testid="survivor-skips-left"
        className="text-body text-ink-secondary"
      >
        {props.view.skipsLeftLabel}
      </p>
      <Button
        variant="secondary"
        data-testid={isDeclare ? "survivor-skip-round" : "survivor-undo-skip"}
        disabled={props.isPending}
        loading={props.isPending}
        onClick={isDeclare ? props.onSkip : props.onUndo}
      >
        {isDeclare ? SURVIVOR_SKIP_ROUND_LABEL : SURVIVOR_UNDO_SKIP_LABEL}
      </Button>
    </div>
  );
}
